import { useEffect } from "react";

const SITE = "https://hitwicket.com";

/**
 * Sets the page <title>, meta description, Open Graph tags and canonical URL for the current route,
 * and puts the previous values back when the page unmounts (so pages without their own meta never inherit another page's).
 */
export default function usePageMeta({ title, description, path }) {
  useEffect(() => {
    const previousTitle = document.title;
    const restore = [];

    const setTag = (tag, attrs, attrName, value) => {
      const selector = `${tag}[${Object.entries(attrs).map(([k, v]) => `${k}="${v}"`).join("][")}]`;
      let el = document.head.querySelector(selector);
      const created = !el;
      if (created) {
        el = document.createElement(tag);
        Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
        document.head.appendChild(el);
      }
      const previous = el.getAttribute(attrName);
      el.setAttribute(attrName, value);
      restore.push(() => (created ? el.remove() : el.setAttribute(attrName, previous)));
    };

    if (title) {
      document.title = title;
      setTag("meta", { property: "og:title" }, "content", title);
    }
    if (description) {
      setTag("meta", { name: "description" }, "content", description);
      setTag("meta", { property: "og:description" }, "content", description);
    }
    if (path) {
      setTag("meta", { property: "og:url" }, "content", SITE + path);
      setTag("link", { rel: "canonical" }, "href", SITE + path);
    }

    return () => {
      document.title = previousTitle;
      restore.forEach((fn) => fn());
    };
  }, [title, description, path]);
}
